//* 手机号格式验证
export const phone = (context: string): boolean => {
    return /^[0-9-]{6,24}$/.test(context);
};

//* 邮箱格式验证
export const email = (context: string): boolean => {
    return /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(context);
};
